// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-angola/calculator-angola-business-loan/calculator-angola-business-loan.component.scss
// module id = 630
// module chunks = 0